<!--P002-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'MaterialManage'})">货品维护</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">货品详情</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">货品编号</div>
      <div class="cs_radius_lg txt_info_search">{{search.materialNum}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">货品名称</div>
      <input v-model="search.materialName" @input="transformCnChar" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">拼音码</div>
      <input v-model="search.spellCode" class="cs_input cs_radius_lg edtxt_info_search ui_margin_left_30" placeholder="请输入">
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">货品大类</div>
      <web-select :options="search.serialList"
                  @option-key="updateSerial"
                  v-model="search.serialName"
                  class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm"></web-select>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">货品小类</div>
      <web-select :options="search.typeList"
                  @option-key="updateType"
                  v-model="search.typeName"
                  class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm"></web-select>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">库存单位</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm">{{search.dcStockUnitName}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">规格</div>
      <input v-model="search.materialSpecs" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm ui_margin_left_44" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">启用状态</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm">{{MATERIAL_STATUS[search.isStop]}}</div>
    </div>
    <!--货品属性设置-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">货品属性设置</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="div_cbtn">
        <span class="icon_cbtn" :class="{'on':search.isProduceChecked}"></span>
        <input value="true" class="txt_cbtn" :checked='search.isProduceChecked'  @click="check1" type="checkbox">加工产成品
      </div>
      <div class="div_cbtn">
        <span class="icon_cbtn" :class="{'on':search.isDeptChecked}"></span>
        <input value="true" class="txt_cbtn" :checked='search.isDeptChecked'  @click="check2" type="checkbox">部门可领料
      </div>
      <div class="div_cbtn">
        <span class="icon_cbtn" :class="{'on':search.isCptChecked}"></span>
        <input value="true" class="txt_cbtn" :checked='search.isCptChecked'  @click="check3" type="checkbox">计算万元用量
      </div>
      <div class="div_cbtn">
        <span class="icon_cbtn" :class="{'on':search.isFrozenChecked}"></span>
        <input value="true" class="txt_cbtn" :checked='search.isFrozenChecked'  @click="check4" type="checkbox">冻品
      </div>
    </div>
    <!--加工属性设置-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">加工属性设置</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">配方单位</div>
      <div class="cs_radius_lg txt_info_search">{{search.formulaUnitName}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_xl">单位换算</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_sm">1{{search.dcStockUnitName}}  =</div>
      <input v-model="search.formulaRate" class="cs_input cs_radius_lg edtxt_info_search width_80 margin_left_8" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_xs">{{search.formulaUnitName}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_sm">（将库存单位转换为配方单位）</div>
    </div>
    <!--采购属性设置-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">采购属性设置</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">采购单位</div>
      <div class="cs_radius_lg txt_info_search">{{search.purchaseUnitName}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_xl">单位换算</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_sm">1{{search.purchaseUnitName}}  =</div>
      <input v-model="search.purchaseRate" class="cs_input cs_radius_lg edtxt_info_search width_80 margin_left_8" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_xs">{{search.dcStockUnitName}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_sm">（将采购单位转换为库存单位）</div>
    </div>
    <!--门店库存属性设置-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">门店库存属性设置</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">门店库存单位</div>
      <div class="cs_radius_lg txt_info_search">{{search.shopStockUnitName}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_xl">要货单位换算</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_sm">1{{search.dcStockUnitName}}  =</div>
      <input v-model="search.shopRate" class="cs_input cs_radius_lg edtxt_info_search width_80 margin_left_8" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_xs">{{search.shopStockUnitName}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_sm">（将配送中心库存单位转换为门店库存单位）</div>
    </div>
    <div class="div_operation_table cs_align_center" style="margin-top:56px;">
      <button @click="btnCancel" class="cs_btn cs_btn_sm ui_btn_ghost_blue"
              type="button">取消
      </button>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue ui_margin_left_88"
              type="button">确认
      </button>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select";
  import {MATERIAL_STATUS} from "../../assets/utils/constants"
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  export default {
    name: "MaterialDetail",
    components: {SearchSelect, WebSelect},
    data: function () {
      return {
        MATERIAL_STATUS: MATERIAL_STATUS,
        search: {
          materialNum: "",
          materialName: "",
          spellCode: "",
          serialList: [],
          serialId: 0,
          serialName: "",
          typeList: [],
          typeId: 0,
          typeName: "",
          unitList: [],
          dcStockUnitName: "",
          materialSpecs: "",
          isProduceList: [],
          isProduceChecked: false,
          isDeptList: [],
          isDeptChecked: false,
          isCptList: [],
          isCptChecked: false,
          isFrozenList: [],
          isFrozenChecked: false,
          formulaUnitName: "",
          formulaRate: "",
          purchaseUnitName: "",
          purchaseRate: "",
          shopStockUnitName: "",
          shopRate: "",
          isStop: false,
        },
      }
    },
    created: function () {
      this.showSerial();
      this.showDetail();
    },
    mounted: function() {
    },
    methods: {
      showDetail(){
        this.$ajax.material.acquireMaterialDetail.bind(this)(this.$route.query.id,(data) => {
          this.search.materialNum = data.data.materialNum;
          this.search.materialName = data.data.materialName;
          this.search.spellCode = data.data.spellCode;
          this.search.serialId = data.data.materialSerialId;
          this.search.serialName = data.data.materialSerialName;
          this.search.typeId = data.data.materialTypeId;
          this.search.typeName = data.data.materialTypeName;
          this.search.materialSpecs = data.data.materialSpecs;
          this.search.isProduceList = data.data.isProduce?[data.data.isProduce]:[];
          this.search.isProduceChecked = data.data.isProduce;
          this.search.isDeptList = data.data.isDept?[data.data.isDept]:[];
          this.search.isDeptChecked = data.data.isDept;
          this.search.isCptList = data.data.isCpt?[data.data.isCpt]:[];
          this.search.isCptChecked = data.data.isCpt;
          this.search.isFrozenList = data.data.isFrozen?[data.data.isFrozen]:[];
          this.search.isFrozenChecked = data.data.isFrozen;
          this.search.formulaRate = data.data.formulaRate;
          this.search.purchaseRate = data.data.purchaseRate;
          this.search.shopRate = data.data.shopRate;
          this.search.isStop = data.data.isStop;
          this.search.dcStockUnitName = data.data.dcStockUnit;
          this.search.formulaUnitName = data.data.formulaUnit;
          this.search.purchaseUnitName = data.data.purchaseUnit;
          this.search.shopStockUnitName = data.data.shopStockUnit;
          if(!this.isEmptySelect(data.data.materialSerialId)){
            this.showType(this.search.serialId);
          }
        }, (data) => {
        }, true)
      },
      btnSave(){
        try {
          WhParameter.verifyNotEmpty(this.search.materialNum, "货品编号");
          WhParameter.verifyNotEmpty(this.search.materialName, "货品名称");
          WhParameter.verifyNotEmpty(this.search.spellCode, "拼音码");
          WhParameter.verifyNotEmpty(this.search.formulaRate, "配方单位换算");
          WhParameter.verifyNotEmpty(this.search.purchaseRate, "采购单位换算");
          WhParameter.verifyNotEmpty(this.search.shopRate, "要货单位换算");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        if(this.isEmptySelect(this.search.serialId)){
          this.$toast("请选择货品大类");
          return;
        }
        if(this.isEmptySelect(this.search.typeId)){
          this.$toast("请选择货品小类");
          return;
        }
        this.$ajax.material.modifyMaterial.bind(this)(this.search,(data) => {
          this.$toast("保存成功");
          this.$router.replace({name:'MaterialManage'});
        }, (data) => {
        }, true)
      },
      btnCancel(){
        this.$router.go(-1);
      },

      showSerial(){
        this.$ajax.materialType.listMaterialType.bind(this)(0,(data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].typeName,
            })
          }
          this.search.serialList = array;
        }, (data) => {
        }, true)
      },
      updateSerial(key) {
        this.search.serialId = key;
        this.search.typeList = [];
        this.search.typeId = 0;
        this.search.typeName = "";
        if(!this.isEmptySelect(key)){
          this.showType(key);
        }
      },
      showType(id){
        this.$ajax.materialType.listMaterialType.bind(this)(id,(data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].typeName,
            })
          }
          this.search.typeList = array;
        }, (data) => {
        }, true)
      },
      updateType(key) {
        this.search.typeId = key;
      },
      check1() {
        this.search.isProduceChecked = !this.search.isProduceChecked;
      },
      check2() {
        this.search.isDeptChecked = !this.search.isDeptChecked;
      },
      check3() {
        this.search.isCptChecked = !this.search.isCptChecked;
      },
      check4() {
        this.search.isFrozenChecked = !this.search.isFrozenChecked;
      },
      transformCnChar() {
        let char = this.search.materialName;
        this.search.spellCode = pinyinUtil.getFirstLetter(char);
      },
    },
  }
</script>

<style scoped>
  .margin_left_8{margin-left: 8px;}
  .width_80{width: 80px;}
  .div_cbtn{
    display: inline-block;
    margin-left: 64px;
    position: relative;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    color: #333333;
  }
  .div_cbtn:first-child{margin-left: 0;}
  .txt_cbtn {
    display: inline-block;
    position: absolute;
    opacity: 0;
    width: 22px;
    height: 22px;
    cursor: pointer;
    left: 0;
    outline: none;
    -webkit-appearance: none;
  }
  .icon_cbtn {
    display: inline-block;
    vertical-align: top;
    width: 22px;
    height: 22px;
    cursor: pointer;
    background: url(../../assets/image/icon_cbtn.png) no-repeat center;
    background-size: 16px 16px;
  }
  .on {
    background: url(../../assets/image/icon_cbtn_checked.png) no-repeat center;
    background-size: 16px 16px;
  }
</style>



// WEBPACK FOOTER //
// src/page/material/MaterialDetail.vue